import { render, staticRenderFns } from "./rating-tertiary.vue?vue&type=template&id=25f36d23&scoped=true&"
import script from "./rating-tertiary.vue?vue&type=script&lang=js&"
export * from "./rating-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f36d23",
  null
  
)

export default component.exports